import React from "react";
import classes from "./BasicModal.module.css";
import ModalSkeleton from "@/components/ModalSkeleton";
import Button from "@/components/Button";
import { LOADING_PLACEHOLDER } from "@/constant/constants";
import PropTypes from "prop-types";

export default function BasicModal({
  header = "",
  setShow = () => {},
  show,
  contentLoading = false,
  saveLoading = false,
  onHide = () => {},
  children,
  footerContent = null,
  formik = null,
  saveLabel = "Save",
}) {
  return (
    <div>
      <ModalSkeleton
        loading={contentLoading}
        header={header}
        onHide={onHide}
        setShow={setShow}
        show={show}
        modalStyles={classes.modal}
        showCloseIcon={true}
        showLogo={true}
      >
        <form
          onSubmit={formik ? formik.handleSubmit : null}
          className="h-[50vh] overflow-hidden flex gap-y-2 flex-col"
        >
          <div className="flex-1 flex pe-4 flex-col gap-y-2 overflow-y-auto">
            {children}
          </div>
          <div>
            {footerContent ? (
              footerContent
            ) : (
              <div className="mt-4 gap-x-10 flex justify-center">
                <div className="w-1/3">
                  <Button
                    variant="outlined"
                    label="Cancel"
                    onClick={() => onHide() ?? setShow(false)}
                    type="button"
                    className="mb-2.5"
                    disabled={saveLoading}
                  />
                </div>
                <div className="w-1/3">
                  <Button
                    variant="green-gradient"
                    label={`${saveLoading ? LOADING_PLACEHOLDER : saveLabel}`}
                    type="submit"
                    className="mb-2.5"
                    disabled={saveLoading}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </ModalSkeleton>
    </div>
  );
}

BasicModal.propTypes = {
  header: PropTypes.string,
  setShow: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  show: PropTypes.bool.isRequired,
  contentLoading: PropTypes.bool,
  saveLoading: PropTypes.bool,
  onHide: PropTypes.func,
  children: PropTypes.any,
  footerContent: PropTypes.any,
  formik: PropTypes.object,
};
